import { modalBlogEventPush, modalBlogNewEventPush } from "./components/modalEventPush";
import modalResponseRender from "./components/modalResponseRender";
import modalSpinner from "./components/modalSpinner";

export default function setBlogSubscribeModalHandlers(wpcfModalSelector){
    let wpcFSubscribeSentModalSelector  = $(wpcfModalSelector);

    let wpcfSubscribeNativeSelector     = document.querySelector( '.card-chat .wpcf7' );
    let wpcfFormSubscribeNativeSelector = wpcfSubscribeNativeSelector ? wpcfSubscribeNativeSelector.querySelector('form') : null;
    if(!wpcfFormSubscribeNativeSelector) return;
    let $wpcf = $('.card-chat .wpcf7');
    let $subscribeBlockEvent= $('.card-chat-wrapp.card-right').data('gtm-event');
    let $buttonText = $wpcf.find('button[type=submit] span').text();


    function responseModal(event) {
        let dataAttributesList = wpcFSubscribeSentModalSelector.data();
        console.log(event);
        console.log(event.detail.status);
        modalResponseRender(event, dataAttributesList); 
    }

    $wpcf.find('button').on('click', function (){
        modalBlogEventPush('Сlick Subscribe Newsletters', 'Form Subscription');
        dataLayer.push({
            'event':'EOSCOM', 
            'eventCategory':'EosComEvents', 
            'eventAction':'subscription_button', 
            'eventLabel': 'ready_section', 
            'eventContent':'', 
            'eventPosition':$subscribeBlockEvent ? $subscribeBlockEvent : '', 
            'eventContext': $buttonText ? $buttonText : ''
        });
    })

    $('#modalResponseSent').on('hide.bs.modal', function() {
        $(wpcfFormSubscribeNativeSelector).find('.form-field').removeClass('not-empty');
        wpcfFormSubscribeNativeSelector.reset();
    });

    wpcfFormSubscribeNativeSelector.addEventListener( 'submit', function(event) {
        modalBlogNewEventPush('subscription_submit', 'ready_section', $buttonText);
        modalSpinner($wpcf , 'start');
    }, false );

    wpcfSubscribeNativeSelector.addEventListener( 'wpcf7mailsent', function(event) {
        modalBlogEventPush('Show Suсcess Newsletter Subscription', 'Form Subscription');
        modalBlogNewEventPush('subscription_success', 'ready_section', $buttonText);
        modalSpinner($wpcf , 'stop');
        responseModal(event);
    }, false );
    
    wpcfSubscribeNativeSelector.addEventListener( 'wpcf7mailfailed', function(event) {
        modalBlogEventPush('Show Error Newsletter Subscription', 'Form Subscription');
        modalBlogNewEventPush('subscription_error', 'ready_section', $buttonText);
        modalSpinner( $wpcf , 'stop');
        responseModal(event);
    }, false );

    wpcfSubscribeNativeSelector.addEventListener( 'wpcf7spam', function(event) {
        modalBlogEventPush('Show Error Newsletter Subscription', 'Form Subscription');
        modalBlogNewEventPush('subscription_error', 'ready_section', $buttonText);
        modalSpinner( $wpcf , 'stop');
        responseModal(event);
    }, false );

    wpcfSubscribeNativeSelector.addEventListener( 'wpcf7invalid', function() {
        modalBlogEventPush('Show Error Newsletter Subscription', 'Form Subscription');
        modalBlogNewEventPush('subscription_error', 'ready_section', $buttonText);
        modalSpinner( $wpcf , 'stop');
    }, false );
}
